import { BannerLoaderBlock } from "./banner-loader.styles";

const BannerLoader: React.FC = () => <BannerLoaderBlock />;

export { BannerLoader };
